import { GTMEvent } from './GTMEvent.types'

export const GTMEventPriority = [
  GTMEvent.SERVER_SIDE_TRACKING,
  GTMEvent.PAGE_LOAD,
  GTMEvent.CART_CONTENTS_PUSH,
]
